// === Zod schemas: swms_tasks_backend ===
// Ported from PHP Click2Gro: SwmsTasksBackendModel / SwmsTasksBackend entity
// Table: swms_tasks_backend

import { z } from 'zod';

export const SwmsTasksBackendSchema = z.object({
  id:                 z.number().int().positive(),
  tasks:              z.string().nullable(),
  hazards_risks:      z.string().nullable(),
  control_measures:   z.string().nullable(),
  risk_ranking:       z.number().int().positive().nullable(),
  consequence:        z.string().max(120).nullable(),
  colour_background:  z.string().max(20).nullable(),
  colour_text:        z.string().max(20).nullable(),
  status:             z.number().int().nullable(),
  company_id:         z.number().int().nullable(),
  created_by:         z.string().max(120).nullable(),
  updated_by:         z.string().max(120).nullable(),
  created_at:         z.string().datetime({ offset: true }).nullable(),
  updated_at:         z.string().datetime({ offset: true }).nullable(),
  deleted_at:         z.string().datetime({ offset: true }).nullable(),
});

export const SwmsTasksBackendInsertSchema = SwmsTasksBackendSchema.omit({
  id: true,
  created_at: true,
  updated_at: true,
  deleted_at: true,
}).partial({
  consequence: true,
  colour_background: true,
  colour_text: true,
  status: true,
  company_id: true,
  created_by: true,
  updated_by: true,
});

export const SwmsTasksBackendUpdateSchema = SwmsTasksBackendInsertSchema.partial();

export type SwmsTasksBackend       = z.infer<typeof SwmsTasksBackendSchema>;
export type SwmsTasksBackendInsert = z.infer<typeof SwmsTasksBackendInsertSchema>;
export type SwmsTasksBackendUpdate = z.infer<typeof SwmsTasksBackendUpdateSchema>;
